export const loadingStates = {
    initializing: 1,
    fetching: 2,
    success: 0,
    error: 99,
};

export const analysisColumnKeys = {
    drain: 'drain',
    oneToOneDotFive: 'oneToOneDotFive', // mat_meting
};

export const analysisColumnOptions = [
    { value: analysisColumnKeys.oneToOneDotFive, label: '1:1,5 analyse' },
    { value: analysisColumnKeys.drain, label: 'drainanalyse' },
];
